module.exports = __webpack_public_path__ + "img/mobile.4013e595.svg";